export const accreditingOrganizationsToText = (
  organizations: string[] | null | undefined
): string => (organizations ?? []).join('\n');

export const textToAccreditingOrganizations = (text: string): string[] | null => {
  const organizations = text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
  return organizations.length > 0 ? organizations : null;
};

export const sameAccreditingOrganizations = (
  a: string[] | null | undefined,
  b: string[] | null | undefined
): boolean => {
  const left = a ?? [];
  const right = b ?? [];
  return left.length === right.length && left.every((v, i) => v === right[i]);
};
